module.exports = __webpack_public_path__ + "img/newuse-bg.269c9df6.png";